<template>
  <div
    :id="id"
    class="l-container promo-category-slider offers"
    :class="{ 'add-padding': id === 'beauty' }"
  >
    <div v-if="withHeader" class="promo-header">{{ withHeader }}</div>
    <ui-multiple-swiper white_buttons class="slider-items">
      <ui-multiple-swiper-slide
        v-for="{ name, type, to } in sliderInfo"
        :key="type"
        class="card-item-wrapper"
        :class="{ isBanner: isBanner }"
      >
        <a :href="to" target="_blank" class="card-slider-item">
          <div class="card-title">{{ name }}</div>
          <ui-responsive-image
            :src="`/static/images/promo-category/${type}@2x.png`"
            class="card-img"
            :alt="name"
            :lazy="false"
            :mobile-sizes="{ width: '100%', height: 'auto' }"
            :desktop-sizes="{ width: '100%', height: 'auto' }"
          />
        </a>
      </ui-multiple-swiper-slide>
    </ui-multiple-swiper>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import sliderItemsData from '~/components/promo/promo-category-slider/sliderItems';

interface CattegorySliderItem {
  to: string;
  name: string;
  type: string;
}
type categoriesItems = string[] | string;
const props = defineProps({
  categories: {
    type: [String, Array],
    default: 'all' as categoriesItems,
  },
  withHeader: {
    type: String,
    default: '',
  },
  id: {
    type: String,
    default: '',
  },
  isBanner: {
    type: Boolean,
    default: false,
  },
});

const sliderItems = computed(() => {
  return sliderItemsData;
});

const sliderInfo = computed(() => {
  if (
    (props.categories as categoriesItems) === 'all' ||
    !props.categories.length ||
    typeof props.categories === 'string'
  )
    return sliderItems.value;
  // перебираем categories а не sliderItems, чтоб сортировка элементов была как в массиве "categories"
  return props.categories.reduce((acc: CattegorySliderItem[], c) => {
    const findItem = sliderItems.value.find((i) => i.type === c);
    if (findItem) acc.push(findItem);
    return acc;
  }, []);
});
</script>
<style lang="scss" scoped src="./promo-category-slider.scss"></style>
